module.exports = __webpack_public_path__ + "static/img/img1.bc959f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/img1.jpg
// module id = 4CxR
// module chunks = 1